import styled from "@emotion/styled";
import { Button } from "./Button";
import { FadeIn } from "./FadeIn";

const TagButton = styled(Button)(({ theme }) => ({
  borderRadius: theme.borderRadius.round,
  minHeight: 0,
}));

interface WithIsOpen {
  isOpen: boolean;
}

const TagDropdownWrapper = styled.div({
  flex: "0 0 auto",
  position: "relative",
  zIndex: 5,
});

const TagDropdownToggle = styled(Button, {
  shouldForwardProp: (prop) => prop !== "isOpen",
})<WithIsOpen>(({ theme, isOpen }) => ({
  alignItems: "center",
  display: "flex",
  flex: "0 0 auto",
  fontSize: theme.fontSizes.xxs,
  gap: "0.5em",
  svg: {
    height: "auto",
    transform: isOpen ? "rotate(0deg)" : "rotate(180deg)",
  },
  // TODO: hovering over this adds opacity state to button. looks odd?
  "&::after": {
    display: isOpen ? "block" : "none",
    content: "''",
    position: "fixed",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
}));

const TagDropdownNav = styled(FadeIn)(({ theme }) => ({
  background: theme.colors.bgLight,
  bottom: "-0.5rem",
  boxShadow: theme.boxShadow.dark,
  borderRadius: theme.borderRadius.sm,
  padding: "1rem",
  position: "absolute",
  right: 0,
  textAlign: "left",
  transform: "translateY(100%)",
  width: "max-content",
  zIndex: 11,
  ul: {
    listStyleType: "none",
    margin: 0,
    padding: 0,
  },
  "ul li + li": {
    marginTop: "0.25rem",
  },
  "ul > li::before": {
    content: '"\\200B"',
  },
})).withComponent("nav");

const TagDropdownItem = styled(Button, {
  shouldForwardProp: (prop) => prop !== "isActive",
})<{ isActive: boolean }>(({ theme, isActive }) => ({
  color: isActive ? theme.colors.primary : "inherit",
  fontSize: theme.fontSizes.xs,
  padding: "0.5rem",
  small: {
    color: isActive ? theme.colors.primary : theme.colors.gray60,
    fontSize: "1em",
    marginLeft: "1em",
  },
  "&:hover small": {
    color: "inherit",
  },
}));

export {
  TagButton,
  TagDropdownItem,
  TagDropdownNav,
  TagDropdownToggle,
  TagDropdownWrapper,
};
